import * as React from 'react';
import { Ionicons as Icon } from '@expo/vector-icons';

import Colors from '../../constants/Colors'
import { StyleProp, TextStyle } from 'react-native';

export interface IInputIconProps {
  name: any
  style?: StyleProp<TextStyle>
  focused?: boolean
  size?: number
}

export default function InputIcon({ name, style, focused, size, ...props}: IInputIconProps)  {
  return (
    <Icon
      name={name}
      size={size || 14}
      style={[
        {
          alignSelf: 'center',
          marginLeft: 14,
          marginRight: 8
        },
        style
      ]}
      color={focused ? Colors.inputFocused : Colors.tabIconDefault}
    />
  );
}
